const ProfilesModule = {
    namespaced: true,
    state: {
        refreshKey: null,
        refreshKeyRoleList: null,
        selectedProfileRowId: null
    },
    actions: {
        REFRESH({ state, commit }, refreshKey) {
            commit('SetRefreshProfileList', refreshKey);
        },
        REFRESHASSOCIATED({ state, commit }, refreshKeyRoleList) {
            commit('SetRefreshProfileRoleList', refreshKeyRoleList);
        },
        SELECT_PROFILE_ROW_ID({ state, commit }, selectedProfileRowId) {
            commit('SetProfileRowId', selectedProfileRowId);
        },
    },
    mutations: {
        SetRefreshProfileList: function (state, refreshKey) {
            state.refreshKey = refreshKey;
        },
        SetRefreshProfileRoleList: function (state, refreshKeyRoleList) {
            state.refreshKeyRoleList = refreshKeyRoleList;
        },
        SetProfileRowId: function (state, selectedProfileRowId) {
            state.selectedProfileRowId = selectedProfileRowId;
        }
    },
    getters: {
        GetRefreshProfileList: function (state) {
            try {
                return state.refreshKey;
            } catch (err) {
                return null;
            }
        },
        GetRefreshProfileRoleList: function (state) {
            try {
                return state.refreshKeyRoleList;
            } catch (err) {
                return null;
            }
        },
        GetSelectedProfileRowId: function (state) {
            return state.selectedProfileRowId
        }
    },
};
export default ProfilesModule;